import React from "react";
import { Col, Divider, Form, FormInstance, InputNumber } from "antd";
import styles from "./index.module.scss";
import { preventNonNumericalInput } from "../../../../../utils/preventNonNumericalInput";

interface SaveOfferExtendBillingDateProps {
  form: FormInstance;
}

export function SaveOfferExtendBillingDate({ form }: SaveOfferExtendBillingDateProps) {
  const validExtendDays = () => {
    const { extendDays } = form.getFieldsValue();
    const value = parseInt(extendDays);
    if (isNaN(value) || !value) {
      return Promise.reject("'Extend days' is required");
    } else if (Number(value) > 28) {
      return Promise.reject("'Extend days' cannot be longer than 28 days");
    } else {
      return Promise.resolve();
    }
  };

  return (
    <>
      <Divider className={styles.divider} />
      <Col span={6}>
        <Form.Item
          label="Extend days"
          name="extendDays"
          className={styles.extendDays}
          rules={[
            {
              required: true,
              validator: validExtendDays,
            },
          ]}
          initialValue={10}
        >
          <InputNumber style={{ width: "100%" }} precision={0} onKeyPress={preventNonNumericalInput} step={1} min={1} />
        </Form.Item>
      </Col>
    </>
  );
}
